import moment from 'moment-timezone';

import { IScheduleStatusDTO } from 'src/api/dtos';
import { DATE_TIME_FORMAT } from 'src/shared/constants';
import { ScheduleStatusTypeEnums } from 'src/shared/enums';

import { formatTime, setTimeToDate } from './dates';

export const getSchedulesStatusOutOfRange = (
  statuses: IScheduleStatusDTO[],
  startDate: string | moment.Moment | Date,
  startTime?: string | moment.Moment | Date | null,
  endTime?: string | moment.Moment | Date | null,
): IScheduleStatusDTO[] => {
  return statuses.filter((status) => {
    if (
      status.statusType !== ScheduleStatusTypeEnums.DAY_OFF &&
      status.statusType !== ScheduleStatusTypeEnums.PUBLISHED
    ) {
      return false;
    }

    if (status.startTime) {
      const timeInput = setTimeToDate(startDate, startTime).format(DATE_TIME_FORMAT);
      const granularity = !startTime ? 'day' : undefined;
      const isOutOfRange = moment(timeInput).isBefore(moment(status.startTime).format(DATE_TIME_FORMAT), granularity);

      if (isOutOfRange) {
        return true;
      }
    }

    if (status.endTime) {
      const timeInput = setTimeToDate(startDate, endTime).format(DATE_TIME_FORMAT);
      const granularity = !endTime ? 'day' : undefined;
      const isOutOfRange = moment(timeInput).isAfter(moment(status.endTime).format(DATE_TIME_FORMAT), granularity);

      if (isOutOfRange) {
        return true;
      }
    }

    return status.statusType === ScheduleStatusTypeEnums.DAY_OFF;
  });
};

export const getScheduleStatusDescription = (
  { startTime, endTime, statusName, statusType }: IScheduleStatusDTO,
  timeFormat: string | undefined,
): string => {
  const status = statusName || '';
  const range =
    startTime && endTime
      ? `${formatTime(startTime, timeFormat, DATE_TIME_FORMAT)} - ${formatTime(endTime, timeFormat, DATE_TIME_FORMAT)}`
      : '';

  if (statusType === ScheduleStatusTypeEnums.PUBLISHED) {
    return range;
  }

  return range ? `${range} ${status}` : status;
};
